/* tslint:disable */
/* eslint-disable */
/**
 * compass-pro
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EmergencyMessageSelfDelete
 */
export interface EmergencyMessageSelfDelete {
    /**
     * 
     * @type {string}
     * @memberof EmergencyMessageSelfDelete
     */
    emergency_id: string;
    /**
     * 
     * @type {string}
     * @memberof EmergencyMessageSelfDelete
     */
    id: string;
}

/**
 * Check if a given object implements the EmergencyMessageSelfDelete interface.
 */
export function instanceOfEmergencyMessageSelfDelete(value: object): value is EmergencyMessageSelfDelete {
    if (!('emergency_id' in value) || value['emergency_id'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function EmergencyMessageSelfDeleteFromJSON(json: any): EmergencyMessageSelfDelete {
    return EmergencyMessageSelfDeleteFromJSONTyped(json, false);
}

export function EmergencyMessageSelfDeleteFromJSONTyped(json: any, ignoreDiscriminator: boolean): EmergencyMessageSelfDelete {
    if (json == null) {
        return json;
    }
    return {
        
        'emergency_id': json['emergency_id'],
        'id': json['id'],
    };
}

export function EmergencyMessageSelfDeleteToJSON(json: any): EmergencyMessageSelfDelete {
    return EmergencyMessageSelfDeleteToJSONTyped(json, false);
}

export function EmergencyMessageSelfDeleteToJSONTyped(value?: EmergencyMessageSelfDelete | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'emergency_id': value['emergency_id'],
        'id': value['id'],
    };
}

